
import SocketClient from './socket-client.js';

import WifiClient from './wifi-client.js'
import NetworkClient from './network-client.js'
import RpiClient from './rpi-client.js'
import GpsClient from './gps-client.js'
import RfidClient from './rfid-client.js'
import VideoClient from './video-client.js'
import VideoPlayerClient from './video-player-client.js'
import DisplayClient from './display-client.js'

/**
 * Main client
 */
class Index {

  constructor() { }

  /**
   * Initialize the secure communication between client and the server
   * 
   * @param {string} serverUrl 
   * @param {string} preSharedToken 
   * @returns {Promise<string>} - JWT based token
   */
  async init(serverUrl, preSharedToken) {
    const autoLogin = true;
    this.client = new SocketClient(serverUrl, preSharedToken, autoLogin)

    //login using pre-shared token if required
    await this.client.login()

    //securely connect with web-socket
    await this.client.connect()

    this.registerClients()
    return this.client.authToken
  }

  registerClients() {
    window.Rpi = new RpiClient(this.client.socket)
    window.NetworkStatusIndicator = new NetworkClient(this.client.socket)
    window.Wifi = new WifiClient(this.client.socket)
    window.Gps = new GpsClient(this.client.socket)
    window.Rfid = new RfidClient(this.client.socket)
    window.VideoManager = new VideoClient(this.client.socket)
    window.VideoPlayer = new VideoPlayerClient(this.client.socket)
    window.Display = new DisplayClient(this.client.socket)
  }

  closeSocket() {
    this.client.disconnect()
  }
}

/**
 * Initialize library
 * 
 * @param {string} serverUrl 
 * @param {string} preSharedToken 
 * @returns {Promise<string>} sessionToken
 */
async function init(serverUrl, preSharedToken) {
  const clientMain = new Index()
  const sessionToken = await clientMain.init(serverUrl, preSharedToken)
  return sessionToken
}

export default init